export default "__VITE_ASSET__CLoTulyv__"